import React, { Fragment, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { IconContext } from "react-icons/lib";
import Cookies from "universal-cookie";

import { SidebarDataAdmin } from "./SidebarDataAdmin";
import { SidebarDataCliente } from "./SidebarDataCliente";
import SubMenu from "./SubMenu";
import logo from "../imagenes/LOGO-Icontec-2019_ver_white.png";

const Nav = styled.div`
  background: #0085ca;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  transition: 350ms;
  z-index: 1000;
`;

const NavButton = styled.button`
  margin-left: 2rem;
  font-size: 2rem;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: none;
  background: transparent;
  color: white;
  cursor: pointer;
`;

const SidebarNav = styled.nav`
  background: #0085ca;
  width: 250px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: 350ms;
  z-index: 1001;
  overflow-y: auto;
`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const Logo = styled.img`
  height: 60px;
  max-width: 220px;
  object-fit: contain;
  margin-right: 2rem;
  margin-left: auto;
`;

const Sidebar = ({ onLogout }) => {
  const [sidebar, setSidebar] = useState(false);

  const showSidebar = () => {
    setSidebar((actual) => !actual);
  };

  const cookie = new Cookies();
  const nitNumber = cookie.get("nitNumber");

  const esAdministrador = String(nitNumber) === "8600123361";

  const menu = esAdministrador ? SidebarDataAdmin : SidebarDataCliente;

  return (
    <Fragment>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav>
          <NavButton
            type="button"
            aria-label="Abrir menú"
            onClick={showSidebar}
          >
            <FaIcons.FaBars />
          </NavButton>

          {esAdministrador && <Logo src={logo} alt="Logo ICONTEC" />}
        </Nav>

        <SidebarNav sidebar={sidebar} aria-label="Menú de navegación">
          <SidebarWrap>
            <NavButton
              type="button"
              aria-label="Cerrar menú"
              onClick={showSidebar}
            >
              <AiIcons.AiOutlineCloseCircle />
            </NavButton>

            {menu.map((item, index) => (
              <SubMenu item={item} key={index} />
            ))}
          </SidebarWrap>
        </SidebarNav>
      </IconContext.Provider>
    </Fragment>
  );
};

export default Sidebar;
